const defaultQuotaState = {
  data: null,
  loading: false,
  error: null,
  success: false,
};

const defaultCandidateState = {
  data: null,
  loading: false,
  error: null,
  success: false,
};

const defaultListState = {
  data: [],
  loading: false,
  error: null,
  pagination: null,
  quota: { total_quota: 0, used_quota: 0 },
  total: 0,
  totalPages: 1,
};

const defaultAssessmentLinkState = {
  data: null,
  loading: false,
  error: null,
  success: false,
};

const defaultResultState = {
  data: null,
  loading: false,
  error: null,
  success: false,
};

// Create Candidate Selectors
export const selectCreateCandidateState = (state) => 
  state?.interviewCandidate?.createCandidate || defaultCandidateState;

export const selectCreateCandidateLoading = (state) => 
  state?.interviewCandidate?.createCandidate?.loading || false;

export const selectCreateCandidateSuccess = (state) => 
  state?.interviewCandidate?.createCandidate?.success || false;

export const selectCreateCandidateError = (state) => 
  state?.interviewCandidate?.createCandidate?.error || null;

export const selectCreateCandidateData = (state) => 
  state?.interviewCandidate?.createCandidate?.data || null;

// Candidate List Selectors
export const selectCandidateListState = (state) => 
  state?.interviewCandidate?.candidateList || defaultListState;

export const selectCandidateList = (state) => 
  state?.interviewCandidate?.candidateList?.data || [];

export const selectCandidateListLoading = (state) => 
  state?.interviewCandidate?.candidateList?.loading || false;

export const selectCandidateListError = (state) => 
  state?.interviewCandidate?.candidateList?.error || null;

export const selectCandidateListPagination = (state) => 
  state?.interviewCandidate?.candidateList?.pagination || null;

// Quota Selector
export const selectCandidateQuota = (state) => 
  state?.interviewCandidate?.candidateList?.quota || { total_quota: 0, used_quota: 0 };

// Add/Update Quota Selectors
export const selectAddUpdateQuotaState = (state) => {
  return state?.interviewCandidate?.addUpdateQuota || defaultQuotaState;
};

export const selectAddUpdateQuotaLoading = (state) => 
  state?.interviewCandidate?.addUpdateQuota?.loading || false;

export const selectAddUpdateQuotaSuccess = (state) => 
  state?.interviewCandidate?.addUpdateQuota?.success || false;

export const selectAddUpdateQuotaError = (state) => 
  state?.interviewCandidate?.addUpdateQuota?.error || null;

export const selectAddUpdateQuotaData = (state) => 
  state?.interviewCandidate?.addUpdateQuota?.data || null;

// Cancel Candidate Selectors
export const selectCancelCandidateState = (state) => 
  state?.interviewCandidate?.cancelCandidate || defaultCandidateState;

export const selectCancelCandidateLoading = (state) => 
  state?.interviewCandidate?.cancelCandidate?.loading || false;

export const selectCancelCandidateSuccess = (state) => 
  state?.interviewCandidate?.cancelCandidate?.success || false;

export const selectCancelCandidateError = (state) => 
  state?.interviewCandidate?.cancelCandidate?.error || null;

export const selectCancelCandidateData = (state) => 
  state?.interviewCandidate?.cancelCandidate?.data || null;

// Assessment Link Selectors
export const selectAssessmentLinkState = (state) => 
  state?.interviewCandidate?.assessmentLink || defaultAssessmentLinkState;

export const selectAssessmentLinkLoading = (state) => 
  state?.interviewCandidate?.assessmentLink?.loading || false;

export const selectAssessmentLinkSuccess = (state) => 
  state?.interviewCandidate?.assessmentLink?.success || false;

export const selectAssessmentLinkError = (state) => 
  state?.interviewCandidate?.assessmentLink?.error || null;

export const selectAssessmentLinkData = (state) => 
  state?.interviewCandidate?.assessmentLink?.data || null;

// Candidate Result Selectors
export const selectCandidateResultState = (state) => 
  state?.interviewCandidate?.candidateResult || defaultResultState;

export const selectCandidateResultLoading = (state) => 
  state?.interviewCandidate?.candidateResult?.loading || false;

export const selectCandidateResultSuccess = (state) => 
  state?.interviewCandidate?.candidateResult?.success || false;

export const selectCandidateResultError = (state) => 
  state?.interviewCandidate?.candidateResult?.error || null;

export const selectCandidateResultData = (state) => 
  state?.interviewCandidate?.candidateResult?.data || null;